<template>
  <div class="inspection-main">
    <div class="inspection-wrap">
      <header class="header">
        <div class="logo">
          <img src="https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745802232691_logo_index_100000.png" />
        </div>
      </header>

      <div class="content">
        <div class="content-t">
          <p>请选择登记机关所在地</p>
          <span @click="gotoPage('index')">返回首页</span>
        </div>

        <div class="content-b">
          <ul>
            <li>
              <label>华北</label>
              <span @click="gotoPage('login')">北京</span>
              <span>天津</span>
              <span>河北</span>
              <span>山西</span>
              <span>内蒙古</span>
            </li>
            <li>
              <label>东北</label>
              <span>辽宁</span>
              <span>吉林</span>
              <span>黑龙江</span>
            </li>
            <li>
              <label>华东</label>
              <span>上海</span>
              <span>江苏</span>
              <span>浙江</span>
              <span>安徽</span>
              <span>福建</span>
              <span>江西</span>
              <span>山东</span>
            </li>
            <li>
              <label>华南</label>
              <span>广东</span>
              <span>广西</span>
              <span>海南</span>
            </li>
            <li>
              <label>华中</label>
              <span>河南</span>
              <span>湖北</span>
              <span>湖南</span>
            </li>
            <li>
              <label>西南</label>
              <span>重庆</span>
              <span>四川</span>
              <span>贵州</span>
              <span>云南</span>
              <span>西藏</span>
            </li>
            <li>
              <label>西北</label>
              <span>陕西</span>
              <span>甘肃</span>
              <span>青海</span>
              <span>宁夏</span>
              <span>新疆</span>
              <span>兵团</span>
            </li>
          </ul>
        </div>
      </div>

      <ul class="link">
        <li>
          <span>惠企政策</span>
          <p>市场监管总局年报服务月入口</p>
        </li>

        <li>
          <span>国家市场监督管理总局作出的行政处罚</span>
          <p>列入严重违法失信名单企业信用修复入口</p>
        </li>
      </ul>
    </div>

    <div class="inspection-footer">
      <div class="content">
        <p>主办单位：国家市场监督管理总局</p>
        <p>地址：北京市西城区三里河东路八号&nbsp;&nbsp;&nbsp;邮政编码：100820&nbsp;&nbsp;&nbsp;备案号：京ICP备18022388号-2&nbsp;&nbsp;&nbsp;010-88650267 010-88650265</p>
        <p>
          <span>业务咨询与技术支持联系方式</span>
          <span>使用帮助</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(["gotoPage"]);

const gotoPage = (page) => {
  emits("gotoPage", page);
};
</script>

<style scoped lang="scss">
.inspection-main {
  background-color: #fbf8ef;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;

  .inspection-wrap {
    overflow: hidden;
    flex-shrink: 0;

    .header {
      height: 118px;
      box-sizing: border-box;
      border-top: 10px solid #ab812d;
      background: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745802460163_index-bg-zizhan.png) no-repeat;
      background-size: 100% 108px;
      box-shadow: 0 1px 3px #cccccc;

      .logo {
        width: 1140px;
        margin: 20px auto 0;
      }
    }

    .content {
      width: 935px;
      margin: 65px auto 30px;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0 1px 1px #cccccc;
      overflow: hidden;

      .content-t {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44px;
        background-color: #ab812d;
        color: #ffffff;
        padding: 0 12px;

        p {
          position: relative;
          font-size: 18px;
          letter-spacing: 2px;
          padding-left: 14px;

          &::before {
            content: "";
            width: 0;
            height: 0;
            border-left: 6px solid #fff;
            border-top: 6px solid transparent;
            border-bottom: 6px solid transparent;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        span {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 76px;
          height: 28px;
          background-color: #d1ab62;
          border-radius: 5px;
          cursor: pointer;
        }
      }

      .content-b {
        width: 520px;
        margin: 0 auto;
        padding: 60px 0 46px;

        ul {
          li {
            display: flex;
            align-items: center;
            line-height: 1;
            height: 34px;

            label {
              padding-left: 15px;
              padding-right: 27px;
              margin-right: 8px;
              border-right: 1px solid #000000;
              color: #87550f;
              font-weight: bold;
            }

            span {
              padding: 6px 10px;
              cursor: pointer;
              border-radius: 5px;
              margin: 0 3px;

              &:hover {
                color: #ffffff;
                background-color: #ab812d;
              }
            }
          }
        }
      }
    }

    .link {
      width: 935px;
      margin: 0 auto 30px;
      display: flex;
      justify-content: space-between;
      color: #8e5300;

      li {
        width: 48%;
        height: 70px;
        text-align: center;
        background-image: url(https://renhe-platform-pre.oss-cn-shanghai.aliyuncs.com/2025-04-28/1745806266184_btbg_hqzt.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:nth-of-type(1) {
          span {
            width: 76px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 5px;
            background-color: #ddc8a4;
          }
        }

        > p {
          font-size: 16px;
          font-weight: bold;
          margin-top: 5px;
        }
      }
    }
  }

  .inspection-footer {
    border-top: 1px solid #d5d5d5;
    flex-shrink: 0;
    text-align: center;
    font-size: 12px;
    color: #8d8d8d;
    padding: 20px 0 30px 0;
    position: relative;
    background-color: #ffffff;

    .content {
      line-height: 1.8;

      span {
        color: rgb(0, 0, 255);
        cursor: pointer;

        &:not(:nth-last-of-type(1)) {
          margin-right: 20px;
        }
      }
    }

    .app {
      position: absolute;
      left: 80px;
      top: 20px;
      display: flex;
      text-align: center;

      li {
        width: 50px;
        cursor: pointer;

        &:not(:nth-of-type(1)) {
          margin-left: 30px;
        }

        img {
          width: 50px;
          height: 50px;
        }

        p {
          line-height: 1.2;
        }
      }
    }
  }
}
</style>
